import S from 'common/service/sanctuary';
import { createSelector } from 'reselect';

export const getErrorContext = ({ error, ...scope }) => (
  error
    ? S.Left(error)
    : S.Right(scope)
);

export const factory = getScope => ({
  getErrorContext: createSelector(
    getScope,
    getErrorContext,
  ),
});

export default factory;
